import { createAction, props } from '@ngrx/store';
import { PatientNetworkModel } from '../../../data-models';

export const loadWaitingData = createAction(
  '[Patients Waiting] Load',
  props<{ columns: string[]; collection: PatientNetworkModel[] }>()
);
export const clearWaitingData = createAction('[Patients Waiting] Clear');
